import Mining from './index';
import Double from './Double';
import Share from './Share';
import Summary from './Summary';

export default {
  path: '/home/mining',
  component: Mining,
  children: [
    { path: '/home/mining/double', component: Double },
    { path: '/home/mining/share', component: Share },
    { path: '/home/mining/summary', component: Summary }
  ]
};
